export default __webpack_public_path__ + "static/media/SWT1800.34I-39820_-23652_0.f34756fb.jpg";